var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M17.7598 7.34C19.5106 7.34 20.9298 5.92074 20.9298 4.17C20.9298 2.41926 19.5106 1 17.7598 1C16.0091 1 14.5898 2.41926 14.5898 4.17C14.5898 5.92074 16.0091 7.34 17.7598 7.34Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M4.17 7.34C5.92074 7.34 7.34 5.92074 7.34 4.17C7.34 2.41926 5.92074 1 4.17 1C2.41926 1 1 2.41926 1 4.17C1 5.92074 2.41926 7.34 4.17 7.34Z",
    fill: "#91BC68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9708 20.9298C12.7215 20.9298 14.1408 19.5106 14.1408 17.7598C14.1408 16.0091 12.7215 14.5898 10.9708 14.5898C9.22004 14.5898 7.80078 16.0091 7.80078 17.7598C7.80078 19.5106 9.22004 20.9298 10.9708 20.9298Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7598 7.34C19.5106 7.34 20.9298 5.92074 20.9298 4.17C20.9298 2.41926 19.5106 1 17.7598 1C16.0091 1 14.5898 2.41926 14.5898 4.17C14.5898 5.92074 16.0091 7.34 17.7598 7.34Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17 7.34C5.92074 7.34 7.34 5.92074 7.34 4.17C7.34 2.41926 5.92074 1 4.17 1C2.41926 1 1 2.41926 1 4.17C1 5.92074 2.41926 7.34 4.17 7.34Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16998 7.33984V8.24984C4.15998 9.73984 5.36998 10.9598 6.85998 10.9698C6.86998 10.9698 6.87998 10.9698 6.87998 10.9698H15.03C16.52 10.9798 17.74 9.76984 17.75 8.27984C17.75 8.26984 17.75 8.25984 17.75 8.25984V7.33984",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9707 10.9702V14.5902",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a95d1848ede0c32da1376ec89b6315cc.svg";
export { ForwardRef as ReactComponent };